import React, { useEffect, useState } from "react";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Box } from "@mui/system";
import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import authAxios from "setups/axios";
import { toastMessage } from "utils/toastMessage";
import toast, { Toaster } from "react-hot-toast";
import Chart from "react-apexcharts";
import { getVisitsByTimeSpent, getVisitsData } from "_controllers/officer";
import { useSelector } from "react-redux";
import AdminDashboard from "./AdminDashboard";
import ZonalManagerDashboard from "./ZonalManagerDashboard";
import RegionalManagerDashboard from "./RegionalManagerDashboard";
import AreaManagerDashboard from "./AreaManagerDashboard";

const Main = () => {
  const { user } = useSelector((state) => state.user);
  console.log("user ------------", user);

  // const [visitByDistance, setVisitByDistance] = useState();
  // const [visitsData, setVisitsData] = useState();
  // const [visitType, setVisitType] = useState();
  // const [visitDealerStatus, setVisitDealerStatus] = useState();
  // const [uniqueVisits, setUniqueVisits] = useState();
  // const [activeVisits, setActiveVisits] = useState();
  // const [loading, setLoading] = useState(true);
  // const [visitLoading, setVisitLoading] = useState(true);
  // const handleSync = async (e, value) => {
  //   let url = `/api/v1/sync/all`;

  //   await authAxios()({
  //     url,
  //     method: "GET",
  //   })
  //     .then((response) => {
  //       toastMessage(response?.data?.message, "success");
  //     })
  //     .catch((err) => {
  //       console.log("error", err);
  //     });
  // };
  // console.log("object");

  // useEffect(async () => {
  //   console.log("inside");
  //   const data = await getVisitsData({
  //     // zone,
  //     // startDate,
  //     // endDate,
  //   });
  //   console.log("ji data", data);
  //   setVisitsData(data);
  //   setVisitType(data?.visitType);
  //   let filterData = data?.visitByDealerStatus.filter(
  //     (d) => d?._id.includes("I") || d?._id.includes("A")
  //   );
  //   // console.log("filetre", filterData);
  //   // var object = filterData.reduce(
  //   //   (obj, item) => ((obj[item.key] = item.value), obj),
  //   //   {}
  //   // );
  //   // var newObj = Object.assign(
  //   //   {},
  //   //   ...filterData.map((item) => ({ [item.key]: item.value }))
  //   // );
  //   // var mapped = filterData.map((item) => ({ [item._id]: item.count }));
  //   // var newObj = Object.assign({}, ...mapped);
  //   let object = filterData.reduce(
  //     (obj, item) => ((obj[item._id] = item.count), obj),
  //     {}
  //   );
  //   console.log("fils", object);
  //   setVisitDealerStatus(object);
  //   setUniqueVisits(data?.uniqueDealerVisits);
  //   setActiveVisits(data?.activeDealerVisits);
  //   setVisitLoading(false);
  // }, []);

  // useEffect(async () => {
  //   console.log("inside");
  //   const data = await getVisitsByTimeSpent({
  //     // zone,
  //     // startDate,
  //     // endDate,
  //   });
  //   // console.log("ji data", plan);
  //   setVisitByDistance(data);
  //   setLoading(false);
  // }, []);

  // console.log("data", visitByDistance);

  return (
    // <>
    //   <Grid
    //     container
    //     spacing={2}
    //     style={{
    //       border: "1px solid #eaeaea",
    //       margin: "1rem",
    //       width: "96.5%",
    //       borderRadius: "10px",
    //       boxShadow:
    //         "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
    //     }}
    //   >
    //     <Grid item xs={12} md={12} xl={12}>
    //       <Typography align="center" variant="h4" sx={{ mt: 1, mb: 2.5 }}>
    //         ADMIN DASHBOARD
    //       </Typography>
    //     </Grid>
    //     {visitLoading === true ? (
    //       <CircularProgress />
    //     ) : (
    //       <Grid item xs={12} md={6}>
    //         <Chart
    //           type="donut"
    //           width={600}
    //           height={400}
    //           series={[visitType.planned, visitType.unplanned]}
    //           options={{
    //             labels: ["Planned", "Unplanned"],
    //             title: {
    //               text: "Visit Type",
    //               align: "center",
    //             },
    //             plotOptions: {
    //               pie: {
    //                 startAngle: -90,
    //                 endAngle: 90,
    //                 // offsetY: 10,
    //               },
    //             },
    //             yaxis: {
    //               labels: {},
    //             },
    //             legend: {
    //               position: "top",
    //             },
    //           }}
    //         ></Chart>
    //       </Grid>
    //     )}

    //     {visitLoading === true ? (
    //       <CircularProgress />
    //     ) : (
    //       <Grid item xs={12} md={6}>
    //         <Chart
    //           type="donut"
    //           width={600}
    //           height={400}
    //           series={[visitDealerStatus?.A, visitDealerStatus?.I]}
    //           options={{
    //             labels: ["Active", "In-Active"],
    //             title: {
    //               text: "Visit By Dealer Status",
    //               align: "center",
    //             },
    //             plotOptions: {
    //               pie: {
    //                 startAngle: -90,
    //                 endAngle: 90,
    //                 // offsetY: 10,
    //               },
    //             },
    //             yaxis: {
    //               labels: {},
    //             },
    //             legend: {
    //               position: "top",
    //             },
    //           }}
    //         />
    //       </Grid>
    //     )}

    //     {visitLoading === true ? (
    //       <CircularProgress />
    //     ) : (
    //       <Grid item xs={12} md={6}>
    //         <Chart
    //           type="donut"
    //           width={600}
    //           height={400}
    //           series={[
    //             uniqueVisits?.uniqueVisits,
    //             uniqueVisits?.totalVisits - uniqueVisits?.uniqueVisits,
    //           ]}
    //           options={{
    //             labels: ["Unique Dealers Visits", "Repeated Dealers"],
    //             title: {
    //               text: "Unique Dealer Visits.",
    //               align: "center",
    //             },
    //             plotOptions: {
    //               pie: {
    //                 startAngle: -90,
    //                 endAngle: 90,
    //                 // offsetY: 10,
    //                 donut: {
    //                   labels: {
    //                     show: true,
    //                     name: {
    //                       // title: "jskjaksjksj",
    //                       formatter: function (val) {
    //                         return "Total Visits";
    //                       },
    //                     },
    //                     total: {
    //                       show: true,
    //                       formatter: function (val) {
    //                         return uniqueVisits?.totalVisits;
    //                       },
    //                     },
    //                   },
    //                 },
    //               },
    //             },
    //             // yaxis: {
    //             //   labels: {},
    //             // },
    //             legend: {
    //               position: "top",
    //             },
    //           }}
    //         />
    //       </Grid>
    //     )}

    //     {visitLoading === true ? (
    //       <CircularProgress />
    //     ) : (
    //       <Grid item xs={12} md={6}>
    //         <Chart
    //           type="donut"
    //           width={600}
    //           height={400}
    //           series={[activeVisits?.visits, activeVisits?.totalDealers]}
    //           options={{
    //             labels: ["Unique Dealers", "Active Dealers"],
    //             title: {
    //               text: "Total Visits/ Active Dealer Base",
    //               align: "center",
    //             },
    //             plotOptions: {
    //               pie: {
    //                 startAngle: -90,
    //                 endAngle: 90,
    //                 // offsetY: 10,
    //               },
    //             },
    //             yaxis: {
    //               labels: {},
    //             },
    //             legend: {
    //               position: "top",
    //             },
    //           }}
    //         />
    //       </Grid>
    //     )}

    //     {loading === true ? (
    //       <CircularProgress />
    //     ) : (
    //       <Grid item xs={12} md={6}>
    //         <Chart
    //           type="donut"
    //           width={600}
    //           height={400}
    //           series={[
    //             visitByDistance?.pendingVisits,
    //             visitByDistance?.lessThan100,
    //             visitByDistance?.moreThan100,
    //           ]}
    //           options={{
    //             labels: ["Not-Ended", ">100m", "<100m"],
    //             title: {
    //               text: "Visit By Start & End Location.",
    //               align: "center",
    //             },
    //             yaxis: {
    //               labels: {},
    //             },
    //             legend: {
    //               position: "top",
    //             },
    //           }}
    //         />
    //       </Grid>
    //     )}

    //     <Grid item xs={12} md={6}>
    //       <Chart
    //         type="bar"
    //         width={600}
    //         height={400}
    //         series={[
    //           {
    //             name: "NO",
    //             data: [5, 2, 1, 4, 3],
    //             // color: "greenyellow",
    //           },
    //           {
    //             name: "YES",
    //             data: [15, 13, 10, 12, 18],
    //           },
    //         ]}
    //         options={{
    //           labels: ["NORTH", "WEST", "EAST", "SOUTH-I", "SOUTH-II"],
    //           title: {
    //             text: "PJP planning status.",
    //             align: "center",
    //           },
    //           chart: {
    //             toolbar: {
    //               show: false, //Disable toolbar
    //             },
    //           },

    //           tooltip: { followCursor: true },
    //           yaxis: {
    //             labels: {},
    //           },
    //           legend: {
    //             position: "top",
    //           },
    //         }}
    //       />
    //     </Grid>

    //     <Grid item xs={12} md={6}>
    //       <Chart
    //         type="bar"
    //         width={600}
    //         height={400}
    //         series={[
    //           {
    //             name: "Last Month",
    //             data: [5.1, 2.5, 3.4, 4.0, 3.2],
    //             // color: "greenyellow",
    //           },
    //           {
    //             name: "Current Month",
    //             data: [4.5, 3.0, 2.8, 5.2, 1.8],
    //           },
    //         ]}
    //         options={{
    //           labels: ["NORTH", "WEST", "EAST", "SOUTH-I", "SOUTH-II"],
    //           title: {
    //             text: "Average Dealer Visits/Day.",
    //             align: "center",
    //           },
    //           chart: {
    //             toolbar: {
    //               show: false, //Disable toolbar
    //             },
    //           },
    //           legend: {
    //             position: "top",
    //           },
    //           tooltip: { followCursor: true },
    //           yaxis: {
    //             labels: {},
    //           },
    //         }}
    //       />
    //     </Grid>

    //     <Grid item xs={12} md={6}>
    //       <Chart
    //         type="bar"
    //         width={600}
    //         height={400}
    //         series={[
    //           {
    //             name: "Last Month",
    //             data: [15.1, 12.5, 23.4, 44.0, 23.2],
    //           },
    //         ]}
    //         options={{
    //           labels: ["NORTH", "WEST", "EAST", "SOUTH-I", "SOUTH-II"],
    //           title: {
    //             text: "Average Time Spent/Dealer (mins).",
    //             align: "center",
    //           },
    //           chart: {
    //             toolbar: {
    //               show: false, //Disable toolbar
    //             },
    //           },

    //           tooltip: { followCursor: true },
    //           yaxis: {
    //             labels: {},
    //           },
    //         }}
    //       />
    //     </Grid>
    //   </Grid>
    // </>
    <>
      {(() => {
        // A native manager role picks its own dashboard.
        if (user.role === "AO") return <AreaManagerDashboard />;
        if (user.role === "ZO") return <ZonalManagerDashboard />;
        if (user.role === "RO") return <RegionalManagerDashboard />;

        // ADMIN and any sub-admin granted "/dashboard" see the normal
        // (Admin) dashboard. The AO/ZO/RO dashboards are reserved for the
        // native manager roles above.
        return <AdminDashboard />;
      })()}
    </>
  );
};

const Dashboard = () => {
  return (
    <>
      {/* {console.log("ROLES+++++++==", roles)} */}
      <AccessController roles={["ADMIN", "ZO", "RO", "AO", "SUBADMIN"]}>
        <DashGridL2 Top={TopBar} Main={Main} />
        <Toaster />
      </AccessController>
    </>
  );
};

export default Dashboard;
